// removed by extract-text-webpack-plugin
module.exports = {"container":"E42kuTyBsvRs5MWHPrQwl","homeContent":"_1H4Ym7-t8k541bqPLj2MzA","compactContent":"tG9Gd3AmqwplR5Yv6UDm0","page":"_19cECsjLtlvodIQwW9nHB-","anchor":"_32SAY8WYMCHVb21KHSm1oL","fullWidthSm":"gn0DQkoShLunkVFisO_fE","fullWidthXs":"_2vugcIfNzfNwqp24SPbi8n","narrowContent":"_3GbMv59IcP2MVaXtv4Xe-D","separatorBottom":"_2liEf_YdfNsDfjGfKTn9a","section":"ILZCrX9IFataJOU945U7","separatorTop":"_4fn572y2IjAcnZGcHprGo","h3":"_1lYiIz9f_YW9FnCi43aIea","row":"_1VGKpJuEtvH_294dbsXlXl","wide-border":"_1cIjbhnHhMlJacIUhT3qsl","content":"V21lrIFnBIh_iQI-z0kd7"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuickSend/QuickSendNew/QuickSendNew.scss
// module id = 1376
// module chunks = 1